import {gsap} from "gsap";
import $ from "jquery";
import CustomAnimations from "src/scripts/modules/CustomAnimations";
import {isMobile} from "detect-touch-device";

const animations = new CustomAnimations();

function showImprint() {

  // block scroller
  if(!isMobile) {
    let smoother = animations.getSmoother();
    smoother.paused(true);
  }

  $('.top_logo').addClass('navi_is_open');
  gsap.fromTo('.imprint',
    {
      rotate: 0,
      top: '140%',
      scale: 1.2,
      duration:0
    },
    {
      rotate: 0,
      duration: .75,
      ease: "expo.out",
      repeat: 0,
      scale: 1,
      top: '0%',
      onComplete: function(){
        $('.close_button').addClass('show');
      },
    });

  gsap.fromTo('.imprint_holder',
    {
      y: '400px',
      duration:0,
      alpha: 0
    },
    {
      duration: 1.5,
      ease: "expo.out",
      scale: 1,
      delay: .4,
      alpha: 1,
      y:0
    });
}
function showPolicy() {

  // block scroller
  if(!isMobile) {
    let smoother = animations.getSmoother();
    smoother.paused(true);
  }

  $('.top_logo').addClass('navi_is_open');
  gsap.fromTo('.policy',
    {
      rotate: 0,
      top: '140%',
      scale: 1.2,
      duration:0
    },
    {
      rotate: 0,
      duration: .75,
      ease: "expo.out",
      repeat: 0,
      scale: 1,
      top: '0%',
      onComplete: function(){
        $('.close_button').addClass('show');
      },
    });



  gsap.fromTo('.policy_holder',
    {
      y: '400px',
      duration:0,
      alpha: 0
    },
    {
      duration: 1.5,
      ease: "expo.out",
      scale: 1,
      delay: .4,
      alpha: 1,
      y:0
    });
}
function hideLayer() {



  // block scroller
  if( $('#mainNav').css('top') != '0px') {

    $('.top_logo').removeClass('navi_is_open');

    if(!isMobile) {
      let smoother = animations.getSmoother();
      smoother.paused(false);
    }
  }



  //ScrollTrigger.normalizeScroll(true);
  $('.close_button').removeClass('show')

  gsap.to('.imprint', {
    rotate: 0,
    top: '140%',
    scale: 1.2,
    duration: .75,
    onComplete: function(){  },
  });

  gsap.to('.policy', {
    rotate: 0,
    top: '140%',
    scale: 1.2,
    duration: .75,
    onComplete: function(){  },
  });
}

class ModuleModal {
  init() {
    this.initListener();
  }

  initListener = () => {

    // imprint
    $('.btn_imprint').click(function(e) {
      e.preventDefault();
      showImprint();
    });

    // policy
    $('.btn_policy').click(function(e) {
      e.preventDefault();
      showPolicy();
    });

    // close button
    $('.close_button').click(function(e) {
      e.preventDefault();
      hideLayer();
    });
  }
}

export default ModuleModal;
